import { render } from "./Logistic.vue?vue&type=template&id=91f13c3a"
import script from "./Logistic.vue?vue&type=script&lang=js"
export * from "./Logistic.vue?vue&type=script&lang=js"

import "./Logistic.vue?vue&type=style&index=0&id=91f13c3a&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__